var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M128,10c-48.8,0-88.5,39.8-88.5,88.7c0,73.2,82.6,143.5,86.1,146.5c0.7,0.6,1.5,0.9,2.4,0.9s1.7-0.3,2.3-0.8c3.5-2.9,86.2-72,86.2-146.5C216.5,49.8,176.8,10,128,10z M128,237.4c-13.6-12.1-81.2-75.7-81.2-138.8c0-44.8,36.4-81.3,81.1-81.3s81.1,36.5,81.1,81.3C209.1,162.8,141.6,225.5,128,237.4z M128,54.3c-24.4,0-44.3,19.8-44.3,44.3c0,24.4,19.9,44.2,44.3,44.2s44.3-19.8,44.3-44.3S152.4,54.3,128,54.3z M128,135.4c-20.3,0-36.9-16.5-36.9-36.9c0-20.3,16.5-36.9,36.9-36.9s36.9,16.5,36.9,36.9C164.9,118.8,148.3,135.4,128,135.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5f14145473ee71253637a7cbd4559973.svg";
export { ForwardRef as ReactComponent };